import { CheckoutOverviewStep } from './CheckoutOverviewStep'
import { CompanyDetailsAndPaymentStep } from './CompanyDetailsAndPaymentStep'
import { KillerQuestionsStep } from './KillerQuestionsStep'
import { SignPoaStep } from './SignPoaStep'

export const CheckoutStepKeys = {
  overview: 'overview',
  payment: 'payment',
  killerQuestions: 'killerQuestions',
  companyDetails: 'companyDetails',
  companyDetailsAndPayment: 'companyDetailsAndPayment',
  poa: 'poa',
}

export const checkoutSteps = {
  [CheckoutStepKeys.overview]: CheckoutOverviewStep,
  [CheckoutStepKeys.companyDetailsAndPayment]: CompanyDetailsAndPaymentStep,
  [CheckoutStepKeys.killerQuestions]: KillerQuestionsStep,
  [CheckoutStepKeys.poa]: SignPoaStep,
}

export const checkoutStepIndexes = {
  [CheckoutStepKeys.overview]: 0,
  [CheckoutStepKeys.payment]: 1,
  [CheckoutStepKeys.killerQuestions]: 2,
  [CheckoutStepKeys.companyDetails]: 3,
  [CheckoutStepKeys.poa]: 3,
}
